import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function InvitePage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      // If no token, redirect to login
      navigate('/login', { replace: true });
    } else {
      // Redirect to the accept-invitation route with token in path
      // This maintains consistency with the existing route structure
      navigate(`/accept-invitation/${token}`, { replace: true });
    }
  }, [token, navigate]);

  return <div />;
}
